import { render, staticRenderFns } from "./new-item.vue?vue&type=template&id=07671e72"
import script from "./new-item.vue?vue&type=script&lang=js"
export * from "./new-item.vue?vue&type=script&lang=js"
import style0 from "./new-item.vue?vue&type=style&index=0&id=07671e72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports